import { defineComponent as t, createBlock as s, openBlock as o, unref as n, withCtx as a, createVNode as p } from "vue";
import { ScalarModal as r } from "@scalar/components";
import l from "./TypesenseSearch.vue.js";
const d = /* @__PURE__ */ t({
  __name: "Search",
  props: {
    modalState: {},
    typesenseKey: {},
    typesenseHost: {},
    typesenseCollection: {}
  },
  setup(y) {
    return (e, c) => (o(), s(n(r), {
      "aria-label": "Reference Search",
      state: e.modalState,
      variant: "search"
    }, {
      default: a(() => [
        p(l, {
          typesenseCollection: e.typesenseCollection,
          typesenseHost: e.typesenseHost,
          typesenseKey: e.typesenseKey
        }, null, 8, ["typesenseCollection", "typesenseHost", "typesenseKey"])
      ]),
      _: 1
    }, 8, ["state"]));
  }
});
export {
  d as default
};
